import styled from 'styled-components';
import Button, { ActionButton } from 'components/ui/Button';
import { colours } from 'themes/default';

export const StyledActionButton = styled(ActionButton)`
  margin: 5px;
  height: 20px;

  div {
    font-size: 14px;
    line-height: 20px;
  }
`;

const UnselectedPassengerButton = styled(Button)`
  margin: 0;
  height: 24px;

  div {
    line-height: 24px;
  }
`;

const PassengerButton = styled(UnselectedPassengerButton)`
  background-color: ${colours.Shades.BlueShade40};

  &:hover {
    background-color: ${colours.Core.CoreNavy};
  }

  div {
    color: ${colours.Greyscale.White};
  }
`;

const CenterAlign = styled.span`
  display: flex;
  justify-content: center;
`;
export { CenterAlign, UnselectedPassengerButton, PassengerButton };
